export default "__VITE_ASSET__DBVPcGHF__"